// @flow

import type {ConfigFunction as MarkdocFunctionSchema} from '@markdoc/markdoc';

export const goCurrency: MarkdocFunctionSchema = {
  render(parameters, config): string {
    const currency = (config.variables?.merchant: any)?.currency ?? 'usd';
    return `string(stripe.Currency${currency.toUpperCase()})`;
  },
};
